export default "__VITE_PUBLIC_ASSET__f65bc95f__"